export default __webpack_public_path__ + "videos/particle-glow-trail-silver-1920w.5c66931aef0c724c4e2514c38f882bfb.mp4";